module.exports = __webpack_public_path__ + "img/jrc.00b2513e.jpg";